import React from 'react';
import BudgetView from '../components/budget/BudgetView'
import BudgetStatus from '../components/budget/BudgetStatus'
import Load from '../components/Load'
import {userIsCialIT} from "../constants";

const BudgetContainer = (props) => {
    const isCialIT = userIsCialIT(props.user || {});
    const showCreateTestButton = !props.creatingOrEditingTest && (props.user || {}).group && !isCialIT;
    const loadingGroups = props.loading.retrieveGroup;

    return (
        <div>
            {loadingGroups && <Load/>}

            {!loadingGroups && showCreateTestButton && (
                <button className="schedule-new-test" onClick={props.scheduleNewTest}>
                    Schedule New Test
                </button>
            )}

            <BudgetStatus {...props}/>

            <div className="budget">
                <div className="budget-header">NOISE BUDGET</div>
                {props.loading.retrieveBudget && <Load/>}
                {props.budget && <BudgetView {...props} />}
            </div>
        </div>
    );
}

export default BudgetContainer






// WEBPACK FOOTER //
// ./src/containers/BudgetContainer.jsx